import React, { createContext, useContext, useState, useEffect } from 'react';
import { useUser } from './UserContext';
import { useApi } from '../hooks/useApi';
import { translations } from '../locales';

const LanguageContext = createContext();

export const LanguageProvider = ({ children }) => {
  const { user } = useUser();
  const { updateUserLanguage } = useApi();
  const [language, setLanguage] = useState('ru'); // По умолчанию русский
  const [loading, setLoading] = useState(false);

  // Загружаем язык пользователя при инициализации
  useEffect(() => {
    if (user?.language) {
      setLanguage(user.language);
    }
  }, [user]);

  // Функция для смены языка
  const changeLanguage = async (newLanguage) => {
    if (newLanguage === language) return;

    setLoading(true);
    try {
      // Обновляем язык в БД
      await updateUserLanguage(newLanguage);
      setLanguage(newLanguage);
    } catch (error) {
      console.error('Error updating language:', error);
    } finally {
      setLoading(false);
    }
  };

  // Функция для получения перевода
  const t = (key, params = {}) => {
    let translation = translations[language]?.[key] || translations['ru'][key] || key;
    
    // Заменяем параметры в строке
    Object.keys(params).forEach(param => {
      translation = translation.replace(new RegExp(`{${param}}`, 'g'), params[param]);
    });
    
    return translation;
  };

  // Функция для получения перевода с поддержкой множественного числа
  const tPlural = (key, count, params = {}) => {
    let pluralKey = key;
    
    if (language === 'ru') {
      // Русские правила множественного числа
      if (count === 1) {
        pluralKey = key.replace('Pairs', 'Pair');
      } else if (count >= 2 && count <= 4) {
        pluralKey = key.replace('Pairs', 'PairsPlural');
      }
    }
    
    return t(pluralKey, { count, ...params });
  };

  const value = {
    language,
    changeLanguage,
    t,
    tPlural,
    loading,
    availableLanguages: [
      { code: 'ru', name: 'Русский' },
      { code: 'en', name: 'English' }
    ]
  };

  return (
    <LanguageContext.Provider value={value}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLanguage = () => {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error('useLanguage must be used within a LanguageProvider');
  }
  return context;
}; 